import { render, staticRenderFns } from "./Decouverte.vue?vue&type=template&id=5875f508&scoped=true"
import script from "./Decouverte.vue?vue&type=script&lang=js"
export * from "./Decouverte.vue?vue&type=script&lang=js"
import style0 from "./Decouverte.vue?vue&type=style&index=0&id=5875f508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875f508",
  null
  
)

export default component.exports